import FJCommunityLeft from './FJCommunityLeft.jsx';
import { useSelector, useDispatch } from 'react-redux';
import FJActionCommunity from '../../../redux/action/FJActionCommunity.js';
import useLocalStore from '../../../hooks/useLocalStore.js';
import { useEffect } from 'react';
import FJUtil from '../../../util/FJUtil.js';
const FJCommunityLeftContainer = () => {
    const dispatch = useDispatch();
    const navBarTab = useSelector(state => state.community.navBarTab);
    const guestUserInfo = useSelector(state => state.community.guestUserInfo);
    useLocalStore();
    useEffect(() => {
        dispatch(FJActionCommunity.initNavBarAction());
    }, [dispatch]);
    const _onChangeTabIndex = tab => {
        dispatch(FJActionCommunity.changeNavBarTabAction(tab));
    };
    const onFlexClipClick = () => {
        const flexclipUrl = FJUtil.getCurrentUrl() + 'editor/app';
        window.open(flexclipUrl);
    };
    if (guestUserInfo.guestMode) {
        return null;
    }
    return (
        <FJCommunityLeft navBarTab={navBarTab} onChangeTabIndex={_onChangeTabIndex} onFlexClipClick={onFlexClipClick} />
    );
};

export default FJCommunityLeftContainer;
